import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { MessageService } from 'primeng/api';

export interface Notification {
  message: string;
  type: 'assigned' | 'unassigned' | 'disputed' | 'solved' | 'withdraw';
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSource = new Subject<Notification>();
  notification$ = this.notificationSource.asObservable();

  private progressNotificationKey: string | null = null;
  private hasShownProgress = false;
  private existingToast: any = null; // Add this property declaration

  private progressTextSubject = new BehaviorSubject<string>(''); // Store progress message
  progressText$ = this.progressTextSubject.asObservable();
  constructor(private messageService: MessageService) {}
  showNotification(type: 'assigned' | 'unassigned' | 'disputed' | 'solved' | 'withdraw', count: number = 1): void {
    let message = '';
    const singular = count === 1 ? 'track has been' : 'tracks have been';

    switch(type) {
      case 'assigned':
        message = `${singular} <b>assigned</b>`;
        break;
      case 'unassigned':
        message = `${singular} <b>unassigned</b>`;
        break;
      case 'disputed':
        message = `${singular} <b>disputed</b>`;
        break;
      case 'solved':
        message = `${singular} <b>solved</b>`;
        break;
      case 'withdraw':
        message = `${singular} <b>withdrawn</b>`;
        break;
    }
    this.notificationSource.next({ message, type, count });
  }

  showError(message: string): void {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    console.error(`Notification Error: ${message}`);
  }

  showSuccess(message: string): void {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    console.debug(`Notification Success: ${message}`);
  }

  showInfo(message: string): void {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
  }

  showProgress(message: string): void {
    this.progressNotificationKey = 'progress-notifications';

    if (!this.existingToast) {
      // Create new toast if none exists
      this.existingToast = {
        key: this.progressNotificationKey,
        severity: 'info',
        summary: 'Progress',
        detail: message,
        sticky: true
      };

      this.messageService.add(this.existingToast);
    } else {

      this.messageService.clear(this.progressNotificationKey);
      this.existingToast.detail = message;
      this.messageService.add(this.existingToast);
    }

    this.progressTextSubject.next(message);
  }

  removeProgressNotification(): void {
    if (this.existingToast && this.progressNotificationKey) {
      this.messageService.clear(this.progressNotificationKey);
      this.existingToast = null;
      this.progressNotificationKey = null;
      this.progressTextSubject.next('');
    }
  }
}
